import Immutable from 'immutable';
import ModalConstants from '../../constants/ModalConstants';

const initialState = Immutable.Map();

export default function modal(state = initialState, action) {
  const { modalKey } = action;
  if (!modalKey) {
    return state;
  }

  switch (action.type) {
    case ModalConstants.OPEN_MODAL: {
      if (state.getIn([modalKey, 'open'])) {
        throw new Error(`Another modal with the modalKey "${modalKey}" is already open.`);
      }

      return state.setIn([modalKey, 'open'], true);
    }

    case ModalConstants.CLOSE_MODAL:
      return initialState;

    default:
      return state;
  }
}
